module.exports = __webpack_public_path__ + "static/img/home_logo_1.43e4ece.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home_logo_1.png
// module id = SPRy
// module chunks = 4